// extracted by mini-css-extract-plugin
export default {"layout":"StockOnePage_layout__8nt9F","scrollContainer":"StockOnePage_scrollContainer__hnOEp","flexContainer":"StockOnePage_flexContainer__7Wg-Y"};